type AnalyticsPrimitive = string | number | boolean;

export type AnalyticsEventName =
  | 'enter_main'
  | 'search'
  | 'search_clear'
  | 'sort_change'
  | 'resource_click'
  | 'my_resource_update'
  | 'my_resource_create'
  | 'my_resource_delete'
  | 'my_resource_submit_publish'
  | 'submit_resource'
  | 'submit_resource_error'
  | 'submission_approve'
  | 'submission_reject'
  | 'resource_publish_approve'
  | 'resource_publish_reject'
  | 'resource_publish_bulk_approve'
  | 'resource_publish_bulk_reject';

export type AnalyticsProps = Record<string, AnalyticsPrimitive | null | undefined>;

type VercelAnalyticsPayload = {
  name: string;
  data?: Record<string, AnalyticsPrimitive>;
};

type VercelAnalyticsQueueItem = ['event', VercelAnalyticsPayload];

declare global {
  interface Window {
    va?: (event: 'event', payload: VercelAnalyticsPayload) => void;
    vaq?: VercelAnalyticsQueueItem[];
  }
}

function cleanProps(props?: AnalyticsProps): Record<string, AnalyticsPrimitive> | undefined {
  if (!props) return undefined;

  const cleaned: Record<string, AnalyticsPrimitive> = {};
  for (const [key, value] of Object.entries(props)) {
    if (value === null || value === undefined) continue;
    cleaned[key] = value;
  }
  return Object.keys(cleaned).length > 0 ? cleaned : undefined;
}

export function trackEvent(name: AnalyticsEventName, props?: AnalyticsProps): void {
  if (!import.meta.env.PROD) return;

  const data = cleanProps(props);
  const payload: VercelAnalyticsPayload = data ? { name, data } : { name };

  try {
    if (typeof window.va === 'function') {
      window.va('event', payload);
      return;
    }

    (window.vaq ??= []).push(['event', payload]);
  } catch {
    // no-op
  }
}
